export default __webpack_public_path__ + "static/media/Beco_poster.293a11c5.webp";